/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React from 'react'
import {Link} from 'react-router-dom'
import {getEncryptedRoute, limitLength} from '../../../../reusable'
import {KTIcon} from '../../../helpers'
import {Tr} from '../../../i18n/Tr'

type Props = {
  className: string
  color: string
  toursId: string
  tourName: string
  image: string
  description: string
  maxPeople: string
  progress: string
  deleteTours?: any
  editModalOpen?: any
  isSpecial?: any
  handleSpecialChange?: any
  showEdit?: any
  showDelete?: any
  menuId: any
}

const MixedWidget24: React.FC<Props> = ({
  className,
  color,
  toursId,
  tourName,
  image,
  description,
  maxPeople,
  progress,
  deleteTours,
  editModalOpen,
  isSpecial,
  handleSpecialChange,
  showEdit,
  showDelete,
  menuId,
}) => {
  let t = Tr()
  return (
    <div className={`card ${className}`}>
      <div className='card-body'>
        <div className='d-flex flex-stack'>
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-60px me-5'>
              <span className={clsx(`symbol-label`, `bg-${color}-light`)}>
                <img src={image} className='h-55px w-100 rounded align-self-center' alt='' />
              </span>
            </div>

            <div className='d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3'>
              <Link
                to={getEncryptedRoute('../toursoverview/' , {menuId : menuId})}
                state={{toursId: toursId}}
                className='text-dark fw-bold text-hover-primary fs-5'
              >
                {limitLength(tourName, 22)}
              </Link>
            </div>
          </div>

          <div className='ms-1'>
            {editModalOpen && (
              <>
                {showEdit ? (
                  <button
                    onClick={() => editModalOpen(toursId)}
                    className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                    data-kt-menu-trigger='click'
                    data-kt-menu-placement='bottom-end'
                    data-kt-menu-flip='top-end'
                  >
                    <KTIcon iconName='notepad-edit' className='fs-2' />
                  </button>
                ) : (
                  ''
                )}
              </>
            )}
            {showDelete ? (
              <button
                onClick={() => deleteTours(toursId)}
                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
              >
                <KTIcon iconName='trash-square' className='fs-2' />
              </button>
            ) : (
              ''
            )}
          </div>
        </div>

        <div className='d-flex flex-column w-100 mt-12'>
          <div className='progress h-5px w-100'>
            <div
              className={`progress-bar bg-${color}`}
              role='progressbar'
              style={{width: progress}}
            ></div>
          </div>
        </div>

        <div className='d-flex flex-column mt-10'>
          <div className='text-dark me-2 fw-bold pb-0'>{t('Is Special Tour ?')}</div>
         {showEdit ? <span className='text-muted fw-semibold mb-5 mt-1'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              <input
                className='form-check-input cursor-pointer'
                type='checkbox'
                value='1'
                title={isSpecial == 0 ? 'No' : 'Yes'}
                checked={isSpecial == 0 ? false : true}
                onChange={() => handleSpecialChange(toursId, isSpecial == 1 ? 0 : 1)}
              />
            </label>
          </span> :''}
          <div className='text-dark me-2 fw-bold pb-0'>{t('Capacity')}</div>
          <span className='text-muted fw-semibold mb-5'>
            {maxPeople} {t('Peoples')}
          </span>
          <div className='text-dark me-2 fw-bold pb-1'>{t('Description')}</div>
          <span className='text-muted fw-semibold'>
            <div dangerouslySetInnerHTML={{__html: limitLength(description, 110)}}></div>
          </span>
        </div>
        {/* end:Team */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {MixedWidget24}
